import fileRouteTypeReducer from '../fileRouteTypesReducer';
import undoable, { includeAction } from 'redux-undo';
import * as fileRouteTypesUndoableActionTypes from '../../../fileRouteTypes/UndoableFileRouteTypeActionTypes';

const undoableFileRouteType = undoable(fileRouteTypeReducer, {
  filter: includeAction(Object.keys(fileRouteTypesUndoableActionTypes)),
});

export default undoableFileRouteType;
